<template>
  <div class="card ml-20 mr-20">
    <div class="row">
      <div class="col-md-3"></div>
      <div class="col-md-6 pt-20">
        <h5 class="text-center fw-600">Create Zabbix Monitors (NON-WPO)</h5>
        <div class="form-group">
          <label for="domainNames">Domain Name(s)*</label>
          <tags-input
            element-id="domain-name-tags"
            v-model="domainTags"
            :add-tags-on-comma="true"
            :add-tags-on-space="true"
            :add-tags-on-blur="true"
            :validate="validateDomain"
            placeholder="Type a domain and press Enter, space or comma"
          ></tags-input>
          <small v-if="domainErr" class="text-danger">{{ domainErr }}</small>
        </div>
        <div class="form-group">
          <label for="queueName">IP</label>
          <input v-model="monitorObj.ip" type="text" class="form-control" >
        </div>
        <div class="form-group">
          <label for="queueName">Client Id*</label>
          <input v-model="monitorObj.clientId" type="text" class="form-control" >
        </div>
        <div class="form-group">
          <label for="queueName">Hostbill Service Id*</label>
          <input v-model="monitorObj.hbServiceId" type="text" class="form-control" >
        </div>
        <div class="form-group">
          <label for="queueName">Hostname*</label>
          <input v-model="monitorObj.hbHostname" type="text" class="form-control">
        </div>
        <button @click="saveMonitor" :disabled="domainTags.length === 0 || !monitorObj.hbServiceId || !monitorObj.hbHostname || loading" class="btn btn-primary pull-right">
          Save <i v-if="loading" class="fa fa-spin fa-spinner"></i>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import tagsInput from '@voerro/vue-tagsinput';
import '@voerro/vue-tagsinput/dist/style.css';
import isValidDomain from 'is-valid-domain';

export default {
  name: "NonWpoZabbixMonitors",
  components: { tagsInput },
  data() {
    return {
      monitorObj: {},
      domainTags: [],
      domainErr: '',
      loading: false,
    }
  },
  computed: {
    domains() {
      return this.domainTags.map(t => t.value);
    },
  },
  methods: {
    validateDomain(domain) {
      const ok = isValidDomain(domain);
      this.domainErr = ok ? '' : `"${domain}" is not a valid domain`;
      return ok;
    },
    async saveMonitor() {
      if (this.domains.length === 0) return;
      try {
        this.loading = true;
        const response = await this.$http.post('/monitor/create-non-wpo-monitors', {
          grant_type: 'token',
          domainList: this.domains,
          hbServiceId: this.monitorObj.hbServiceId,
          hbHostname: this.monitorObj.hbHostname,
          ip: this.monitorObj.ip,
          clientId: this.monitorObj.clientId,
        });
        this.showToast(
          { message: `You have successfully created monitors.`, duration: 4000 },
          true,
          'success'
        );
        this.monitorObj = {};
        this.domainTags = [];
      } catch (e) {
        console.log('error', e.toString());
        this.showToast(
          { message: `Something went wrong while creating monitor. ${e.toString()}`, duration: 2000 },
          true,
          'danger'
        );
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>
<style scoped>

</style>
